<script lang="ts">
	import type { IconName } from '$lib/components/icons/types';
	import Link from '$lib/components/atoms/link/Link.svelte';
	import Icon from '$lib/components/icons/Icon.svelte';

	interface Props {
		message: string;
		url?: string;
		label?: string;
		hashtag?: string;
		icon?: IconName;
		iconAriaLabel?: string;
		iconExtraClasses?: string;
		class?: string;
	}

	const {
		message,
		url,
		label,
		hashtag,
		icon,
		iconAriaLabel,
		iconExtraClasses,
		class: classes,
	}: Props = $props();

</script>

<div
	class={['flex p-4 items-center gap-4 self-stretch rd-2 border-1 border-solid text-sm text-primary-strongest', classes]}
>
	{#if icon}
		<Icon {icon} ariaLabel={iconAriaLabel} class={iconExtraClasses} />
	{/if}
	<div class="flex flex-col">
		<div>{message}</div>
		{#if hashtag}
			<div>{hashtag}</div>
		{/if}
	</div>
	{#if url}
		<Link href={url} target="_blank" rel="external" {label} />
	{/if}
</div>
